// Renumber questions globally by order in survey: sorted by pageNumber asc, then by their
// original order within the array. Assign questionID = 1..N (numbers).
export function renumberQuestions(questions = []) {
    const arr = Array.isArray(questions) ? questions : [];
    const withIdx = arr.map((q, idx) => ({ q, idx }));
    const sorted = withIdx.slice().sort((a, b) => {
        const ap = Number(a.q?.pageNumber || 1);
        const bp = Number(b.q?.pageNumber || 1);
        if (ap !== bp) return ap - bp;
        return a.idx - b.idx;
    });

    let normCounter = 0;
    let metricCounter = 1000; // first metric question will be 1001
    const idByIdx = new Map();
    sorted.forEach((item) => {
        const isMetric = !!item.q?.isMetric;
        if (isMetric) {
            metricCounter += 1;
            idByIdx.set(item.idx, metricCounter);
        } else {
            normCounter += 1;
            idByIdx.set(item.idx, normCounter);
        }
    });

    return withIdx.map(({ q, idx }) => ({ ...q, questionID: idByIdx.get(idx) }));
}
